import { resolver } from '../util';
import { queryHelpContent } from '../../models';

// Resolvers
const findAllHelpContent = resolver.compose(
  queryHelpContent('findAllHelpContent'),
);

const findHelpContent = resolver.compose(
  queryHelpContent('findHelpContent'),
  resolver.argProp('component'),
);

export default {
  Query: {
    allHelpContent: findAllHelpContent,
    helpContent: findHelpContent,
  },
};
